// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3Q1o9","addWidgetButton":"Header_addWidgetButton__9s9Ub","dashboardTabs":"Header_dashboardTabs__1IkEK","active":"Header_active__s7861"};